import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import BusinessIcon from "@mui/icons-material/Business";

import Img1 from "../images/1.png";
import Img3 from "../images/3-removebg-preview.png";
import Img4 from "../images/4-removebg-preview.png";
import Img5 from "../images/5-removebg-preview.png";
import Img6 from "../images/6-removebg-preview.png";
import Img7 from "../images/9-removebg-preview.png";

const industries = [
  { name: "Oil & Gas", img: Img1 },
  { name: "Manufacturing", img: Img3 },
  { name: "Construction", img: Img4 },
  { name: "Insurance", img: Img5 },
  { name: "Education", img: Img7 },
  { name: "Banking ", img: Img5 },
  { name: "Healthcare", img: Img6 },
  { name: "Automative", img: Img7 },
];

const Industrie = () => {
  return (
    <Box
      sx={{
        py: 10,
        px: { xs: 2, md: 6 },
        backgroundImage:
          "linear-gradient(to right,rgba(150, 146, 88, 0.2), rgba(88, 150, 131, 0.2), rgba(74, 107, 145, 0.2), rgba(173, 193, 230, 0.2),rgba(88, 150, 131, 0.2),rgba(175, 184, 93, 0.2))",
        borderRadius: 6,
        mx: "auto",
        maxWidth: "1500px",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Box
          sx={{
              display: "inline-flex",
              alignItems: "center",
              backgroundColor: "#fff",
              px: 2,
              py: 0.5,
              borderRadius: 10,
              border: "0.5px solid gray",
              fontWeight: 600,
              gap: 0.5,
              justifyContent: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <BusinessIcon  sx={{ mx: 1, color : "blue" }} />
            <Typography variant="h6" fontWeight="small" align="center" fontSize={{ xs: 12, md: 16 }}
            sx={{fontFamily : "Aeonik" , fontWeight : "bold"}}>
              Industries we work
            </Typography>
          </Box>
        </Box>
        </Box>
        <br />
        <Typography variant="h3" align="center" fontWeight="bold" gutterBottom
        sx={{
          fontFamily : "Aeonik-bold"
        }}
        >
          Serving diverse industries
        </Typography>

        {/* Grid Section */}
        <Box sx={{ mt: 4, px: 4 }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(1, 1fr)", // up to xs (600px by default)
                sm: "repeat(2, 1fr)", // from 600px to 760px approx
                md: "repeat(4, 1fr)", // 960px and above (default md)
              },
              gap: 4,
              // Override for custom breakpoint 760px using media query:
              "@media (max-width:760px)": {
                gridTemplateColumns: "repeat(1, 1fr)", // 2 columns for <=760px
              },
            }}
          >
            {industries.map(({ name, img }, index) => (
              <Box
                key={index}
                sx={{
                  position: "relative",
                  overflow: "hidden",
                  borderRadius: 5,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  bgcolor: "white",
                  height: 200,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 2,
                  cursor: "default",
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                  },
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    right: 0,
                    width: "100%",
                    height: "200%",
                    background:
                      "linear-gradient(135deg, rgba(255, 192, 203, 1) 0%, rgba(255, 0, 0, 0.7) 100%)",
                    transform: "translateX(100%) rotate(45deg)",
                    transition: "transform 0.6s ease-in-out",
                    zIndex: 1,
                  },
                  "&:hover::before": {
                    transform: "translateX(-100%) rotate(135deg)",
                     background:
                      "linear-gradient(135deg, rgba(173, 216, 230, 1) 0%, rgba(7, 0, 102, 0.7) 100%)",
                  },
                  "& > *": {
                    zIndex: 2,
                  },
                  // Smaller height on mobile:
                  "@media (max-width:760px)": {
                    height: 100,
                    p: 1.5,
                  },
                }}
              >
                <Box
                  component="img"
                  src={img}
                  alt={name}
                  sx={{
                    width: 120,
                    height: 100,
                    mt: 1,
                    "@media (max-width:760px)": {
                      width: 70,
                      height: 50,
                    },
                  }}
                />

                <Typography
                  variant="h6" // smaller font size variant on mobile is better
                  fontWeight="bold"
                  textAlign="center"
                  sx={{
                    mb: 1,
                    "@media (max-width:760px)": {
                      fontSize: "0.7rem",
                    },
                  }}
                >
                  {name}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Button */}
        {/* <Box textAlign="center" mt={6}>
          <Button
            variant="h2"
            c
          >
            Book a free consultation
          </Button>
        </Box> */}
      </motion.div>
    </Box>
  );
};

export default Industrie;
